<template>
  <div class="card">
    <div class="card-body" ref="searchBox">
      <div class="d-flex with-button">
        <div class="p-2">
          <h1>오답노트</h1>
        </div>
        <div class="p-2 small bottom">
          총 <strong><span class="number mint">{{tableTotal}}</span></strong> 건
        </div>
        <div class="ml-auto p-2">
          <!-- <button type="button" class="btn btn-info" :disabled="this.examPaperSelection.length === 0" @click="downloadExamPaper('P')" :loading="zipLoading">시험지 일괄 저장</button> -->
          <el-dropdown @command="handleCommand">
            <el-button class="btn btn-info btn-white">
              일괄저장<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="pdf">PDF</el-dropdown-item>
              <el-dropdown-item command="hwp">HWP</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <excel :name="btnExcelName" @click="downloadExcel" :loading="excelLoading" class="btn-dropdown"></excel>
        </div>
      </div>

      <div class="d-flex">
        <div class="p-2 w-100">
          <div class="input-group search">
            <div class="input-group-prepend">
              <span class="input-group-text"><i class="fas fa-search"></i></span>
            </div>
            <input type="text" class="form-control" aria-describedby="basic-addon1" v-model.trim="search.search_text" @keyup.enter="retrieve" placeholder="시험명 / 수강생명">
            <div class="input-group-apend">
              <button type="button" class="btn btn-default" @click="retrieve">
                 검색
              </button>
            </div>
          </div>
        </div>
        <div class="p-2 search-detail" v-if="searchDetailVisible">
          <a href="#" class="arrowdown"><i class="fas fa-angle-double-down"></i></a>
        </div>
      </div>
    </div>

    <stone-data-table-server
      ref="dataTableServer"
      table-ref="dataTableServer"
      class="no-left-margin small-td"
      :loading="searchLoading"
      :columns="tableColumns"
      :data="tableData"
      :table-props="defaultTableProps"
      @selection-change="handleExamSelectionChange"
      @query-change="tableLoadData"
      @row-click="rowClickHandler">
    </stone-data-table-server>

  </div>
</template>

<script>

import common from '@/modules/common'

export default {
  name: 'M050201',
  mixins: [common.mixins],
  data () {
    return {
      tableData: [],
      tableTotal: 0,
      tableColumns: [
        {label: '', prop: 'chk', align: 'center', type: 'selection'},
        {label: 'No', prop: 'rnum', align: 'left', width: 60, sortable: false, class: 'rnum'},
        {label: '시험명', prop: 'exam_title', align: 'left', width: 200},
        {label: '상태', prop: 'stat_name', align: 'center', width: 50},
        {label: '생성일', prop: 'open_dt', align: 'center', width: 80, formatter: this.columnFormatterDate, dataType: 'date', format: 'yyyy.MM.dd'},
        {label: '종료일', prop: 'close_dt', align: 'center', width: 80, formatter: this.columnFormatterDate, dataType: 'date', format: 'yyyy.MM.dd'},
        {label: '수강반', prop: 'class_name', align: 'left', width: 120},
        {label: '수강생명', prop: 'class_user_name', align: 'left', width: 80},
        {label: '참여상태', prop: 'stat_name', align: 'center', width: 80}
      ],
      search: {
        search_text: '',
        title: ''
      },
      examPaperSelection: []
    }
  },
  beforeCreate () {
  },
  created () {
    this.retrieveDummy()
  },
  mounted () {
  },
  methods: {
    retrieve () {
      const queryInfo = {page: 1, pageSize: 20, type: 'init', filters: [], sort: {}}
      this.tableLoadData(queryInfo)
      this.$refs.dataTableServer.localCurrentPage = 1
    },
    async tableLoadData (queryInfo, isClear = false) {
      if (this.checkedPageLoadInit(queryInfo)) {
        return
      }
      const param = Object.assign({query: queryInfo}, this.search)
      this.loadStoneDataTable('/exam/note/list', param, true, false)
        .then(response => {
          this.tableData = response.data
          this.tableTotal = this.tableData && this.tableData.length > 0 ? this.tableData[0].total_count : 0
          this.setQueryParamPaging(isClear)
        })
    },
    goEdit (examSeq) {
      const routerName = 'M050202'
      const param = {
        exam_seq: examSeq
      }
      this.routerPageChangeServer(routerName, param)
    },
    rowClickHandler (row, event, column) {
      if (column.property === 'chk' || column.property === 'rnum') {
        return false
      }
      this.goEdit(row.exam_seq)
    },
    downloadExcel () {
      const param = {
        data: {
          service: 'ExamService',
          method: 'selectExamNote',
          params: this.search
        },
        excel: {
          columns: this.tableColumns,
          file: '오답노트'
        }
      }
      this.exportExcel(param)
    },
    onPopStateEventHandler () {
      if (this.$store.getters.page_params.query_info) {
        this.$route.params.query_info = this.$store.getters.page_params.query_info
      }
    },
    handleExamSelectionChange (value) {
      this.examPaperSelection = value
    },
    downloadExamPaper (type) {
      if (this.examPaperSelection.length === 0) {
        this.$message.warning('다운받을 시험지 대상자를 선택하십시오.')
        return
      }
      const param = {
        data: this.examPaperSelection,
        file_name: 'Oliver_오답노트_' + type,
        file_type: type
      }
      this.exportExamPaperZip(param, 'dataTableServer')
    },
    handleCommand (command) {
      this.downloadExamPaper(command.toUpperCase())
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/M050201.vue